import { forwardRef, ReactNode, useId } from "react";
import { Form, FormControlProps, InputGroup } from "react-bootstrap";
import { FieldError } from "react-hook-form";
import { inputCls, inputErrCls, inputExplCls, inputLabelCls } from "./Theme";

type InputType = "text" | "date" | "time" | "month" | "password" | "email" | "number" | "file" | "tel";

export interface InputProps extends FormControlProps {
    type:            InputType;
    className?:      string;
    inputClassName?: string;
    label:           string;
    icon?:           ReactNode;
    placeholder?:    string;
    error?:          FieldError | undefined;
}

type FormControlElement = HTMLInputElement | HTMLTextAreaElement;
export const Input = forwardRef<FormControlElement, InputProps>(
    ( { type,
        className = inputCls,
        inputClassName = "",
        label,
        icon,
        placeholder = "",
        error,
        ...props
    }, ref ) => {
        const inputId = useId();
        const explId  = `${inputId}-expl`;
        const hasErr  = error !== undefined;
        const hasIcon = icon  !== undefined;
        return <Form.Group className={className}>
            <Form.Label htmlFor={inputId} className={`${inputLabelCls}`}>{label}</Form.Label>
            <InputGroup>
                {hasIcon && <InputGroup.Text>
                    {icon}
                </InputGroup.Text>}
                <Form.Control
                    id={inputId}
                    type={type}
                    ref={ref}
                    className={inputClassName}
                    placeholder={placeholder}
                    aria-describedby={explId}
                    {...props} />
            </InputGroup>
            {hasErr && <Form.Text className={inputErrCls}>
                {error.message}
            </Form.Text>}
        </Form.Group>;
    }
);

Input.displayName = "Input";